import { Tab, Tabs, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { NavLink, useLocation } from "react-router-dom";
import { PATH_DASHBOARD } from "../../routes/paths";
import { menuOptions } from "../../constants/dashboard";

function MobileMenu() {
  const { pathname } = useLocation();
  const [selected, setSelected] = useState(0);
  const { referral } = useSelector((state) => state.DMA);

  useEffect(() => {
    setSelected(menuOptions.find(({ value }) => pathname.includes(value))?.value);
  }, [pathname]);
  return (
    <Tabs
      value={selected}
      classes={{ indicator: "indicator" }}
      textColor="inherit"
      variant="scrollable"
      TabIndicatorProps={{ children: <span /> }}
      sx={{
        "& .indicator": {
          display: "flex",
          justifyContent: "center",
          backgroundColor: "transparent",

          "& > span": {
            height: 3,
            width: "100%",
            backgroundColor: (theme) => theme.palette.primary.main
          }
        },
        width: "100vw",
        minHeight: 46,
        height: 46,
        pl: 2.5,
        borderBottom: (theme) => `0.5px solid ${theme.palette.grey[50]}`
      }}>
      {menuOptions.map(({ title, value }, index) => {
        const isSelected = pathname.includes(value);
        if (value === PATH_DASHBOARD.superReward && referral.type === 0) return null;
        return (
          <Tab
            exact
            to={value}
            key={index}
            value={value}
            onClick={() => setSelected(value)}
            LinkComponent={NavLink}
            activeStyle={{ fontWeight: 600 }}
            disableRipple
            sx={{
              p: 0,
              mr: 2.5,
              minWidth: 34,
              minHeight: 46,
              textAlign: "left"
            }}
            label={
              <Typography sx={{ fontSize: 16, fontWeight: isSelected ? 500 : 300 }}>
                {title}
              </Typography>
            }
          />
        );
      })}
    </Tabs>
  );
}

export default MobileMenu;
